module.exports = __webpack_public_path__ + "img/icon-music-player.88e7fe63.svg";